import { Component, Input, ViewChild } from '@angular/core';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { O2PortalAsuSmrReportService } from "../o2-portal-asu-smr-report.service";
import { AsuSmrReportFilters } from "../types/AsuSmrReportFilters";
import { APLineGraphComponent } from '../ap-line-graph/ap-line-graph.component';
import saveAs from 'file-saver';
import html2canvas from 'html2canvas';
import { Workbook } from 'exceljs';

@Component({
  selector: 'app-asu-smr-charts',
  templateUrl: './asu-smr-charts.component.html',
  styleUrls: ['./asu-smr-charts.component.scss']
})
export class AsuSmrChartsComponent {

  selectedStartAwardYear: string = '2000';
  selectedEndAwardYear: string = (new Date()).getFullYear().toString();
  statusDataSource: any[];
  competitorDataSource: any[];
  segmentDataSource: any[];
  selectedSegment: any;
  selectedStatus: any;
  selectedCompetitor: any;
  asuAndHYCOSOEBusinessModelData: any[];
  asuAndHYCOSOGBusinessModelData: any[];
  asuAndHYCOAllBusinessModelData: any[];
  asuAndHYCOChinaBusinessModelData: any[];
  asuAndHYCOChinaSOEBusinessModelData: any[];
  asuAndHYCOChinaSOGBusinessModelData: any[];
  asuAndHYCORowBusinessModelData: any[];
  asuAndHYCORowSOEBusinessModelData: any[];
  asuAndHYCORowSOGBusinessModelData: any[];
  showCharts: boolean = false;
  isLoadPanelVisible: boolean = false;
  workbook: any;
  chartSections: string[] = ["Global View", "China View", '"Rest Of World" View'];

  globalAllBusinessModelChartId: string = "GlobalAllBusinessModelChart";
  globalSOEBusinessModelChartId: string = "GlobalSOEBusinessModelChart";
  globalSOGBusinessModelChartId: string = "GlobalSOGBusinessModelChart";

  chinaAllBusinessModelChartId: string = "ChinaAllBusinessModelChart";
  chinaSOEBusinessModelChartID: string = "ChinaSOEBusinessModelChart";
  chinaSOGBusinessModelChartId: string = "ChinaSOGBusinessModelChart";

  rowAllBusinessModelChartId: string = "ROWAllBusinessModelChart";
  rowSOEBusinessModelChartId: string = "ROWSOEBusinessModelChart";
  rowSOGBusinessModelChartId: string = "ROWSOGBusinessModelChart";

  @Input() asuAndHYCOInvestmentFilters: AsuSmrReportFilters;

  @ViewChild(("GlobalAllBusinessModelChart"), { static: false }) globalAllBusinessModelChart: APLineGraphComponent;
  @ViewChild(("GlobalSOEBusinessModelChart"), { static: false }) globalSOEBusinessModelChart: APLineGraphComponent;
  @ViewChild(("GlobalSOGBusinessModelChart"), { static: false }) globalSOGBusinessModelChart: APLineGraphComponent;

  @ViewChild(("ChinaAllBusinessModelChart"), { static: false }) chinaAllBusinessModelChart: APLineGraphComponent;
  @ViewChild(("ChinaSOEBusinessModelChart"), { static: false }) chinaSOEBusinessModelChart: APLineGraphComponent;
  @ViewChild(("ChinaSOGBusinessModelChart"), { static: false }) chinaSOGBusinessModelChart: APLineGraphComponent;

  @ViewChild(("ROWAllBusinessModelChart"), { static: false }) rowAllBusinessModelChart: APLineGraphComponent;
  @ViewChild(("ROWSOEBusinessModelChart"), { static: false }) rowSOEBusinessModelChart: APLineGraphComponent;
  @ViewChild(("ROWSOGBusinessModelChart"), { static: false }) rowSOGBusinessModelChart: APLineGraphComponent;


  constructor(private notificationService: NotificationService,
    private o2PortalAsuSmrReportService: O2PortalAsuSmrReportService) {
  }

  getGlobalASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters) {
    this.isLoadPanelVisible = true;
    this.o2PortalAsuSmrReportService.getGlobalASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters).subscribe({
      next: asuAndHYCOAllBusinessModelData => {
        this.asuAndHYCOAllBusinessModelData = asuAndHYCOAllBusinessModelData;
        for (let index = 0; index < this.asuAndHYCOAllBusinessModelData.length; ++index) {
          if (this.asuAndHYCOAllBusinessModelData[index].primaryOfferingType == 'ASU')
            this.asuAndHYCOAllBusinessModelData[index].ASUTotal = this.asuAndHYCOAllBusinessModelData[index].movingAvgInvestment;
          else if (this.asuAndHYCOAllBusinessModelData[index].primaryOfferingType == 'SMR')
            this.asuAndHYCOAllBusinessModelData[index].SMRTotal = this.asuAndHYCOAllBusinessModelData[index].movingAvgInvestment;
        }
        this.isLoadPanelVisible = false;
      }, error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching Global ASU and HYCO All BusinessModel data", error);
      }
    });
  }

  getGlobalASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters) {
    this.isLoadPanelVisible = true;
    this.o2PortalAsuSmrReportService.getGlobalASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters).subscribe({
      next: asuAndHYCOSOEBusinessModelData => {
        this.asuAndHYCOSOEBusinessModelData = asuAndHYCOSOEBusinessModelData;
        for (let index = 0; index < this.asuAndHYCOSOEBusinessModelData.length; ++index) {
          if (this.asuAndHYCOSOEBusinessModelData[index].primaryOfferingType == 'ASU')
            this.asuAndHYCOSOEBusinessModelData[index].ASUTotal = this.asuAndHYCOSOEBusinessModelData[index].movingAvgInvestment;
          else if (this.asuAndHYCOSOEBusinessModelData[index].primaryOfferingType == 'SMR')
            this.asuAndHYCOSOEBusinessModelData[index].SMRTotal = this.asuAndHYCOSOEBusinessModelData[index].movingAvgInvestment;
        }
        this.isLoadPanelVisible = false;
      }, error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching Global ASU and HYCO SOE BusinessModel data", error);
      }
    });
  }

  getGlobalASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters) {
    this.isLoadPanelVisible = true;
    this.o2PortalAsuSmrReportService.getGlobalASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters).subscribe({
      next: asuAndHYCOSOGBusinessModelData => {
        this.asuAndHYCOSOGBusinessModelData = asuAndHYCOSOGBusinessModelData;
        for (let index = 0; index < this.asuAndHYCOSOGBusinessModelData.length; ++index) {
          if (this.asuAndHYCOSOGBusinessModelData[index].primaryOfferingType == 'ASU')
            this.asuAndHYCOSOGBusinessModelData[index].ASUTotal = this.asuAndHYCOSOGBusinessModelData[index].movingAvgInvestment;
          else if (this.asuAndHYCOSOGBusinessModelData[index].primaryOfferingType == 'SMR')
            this.asuAndHYCOSOGBusinessModelData[index].SMRTotal = this.asuAndHYCOSOGBusinessModelData[index].movingAvgInvestment;
        }
        this.isLoadPanelVisible = false;
      }, error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching Global ASU and HYCO SOG BusinessModel data", error);
      }
    });
  }

  getChinaASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters) {
    this.isLoadPanelVisible = true;
    this.o2PortalAsuSmrReportService.getChinaASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters).subscribe({
      next: asuAndHYCOChinaBusinessModelData => {
        this.asuAndHYCOChinaBusinessModelData = asuAndHYCOChinaBusinessModelData;
        for (let index = 0; index < this.asuAndHYCOChinaBusinessModelData.length; ++index) {
          if (this.asuAndHYCOChinaBusinessModelData[index].primaryOfferingType == 'ASU')
            this.asuAndHYCOChinaBusinessModelData[index].ASUTotal = this.asuAndHYCOChinaBusinessModelData[index].movingAvgInvestment;
          else if (this.asuAndHYCOChinaBusinessModelData[index].primaryOfferingType == 'SMR')
            this.asuAndHYCOChinaBusinessModelData[index].SMRTotal = this.asuAndHYCOChinaBusinessModelData[index].movingAvgInvestment;
        }
        this.isLoadPanelVisible = false;
      }, error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching China ASU and HYCO All BusinessModel data", error);
      }
    });
  }

  getChinaASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters) {
    this.o2PortalAsuSmrReportService.getChinaASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters).subscribe({
      next: asuAndHYCOChinaSOEBusinessModelData => {
        this.asuAndHYCOChinaSOEBusinessModelData = asuAndHYCOChinaSOEBusinessModelData;
        for (let index = 0; index < this.asuAndHYCOChinaSOEBusinessModelData.length; ++index) {
          if (this.asuAndHYCOChinaSOEBusinessModelData[index].primaryOfferingType == 'ASU')
            this.asuAndHYCOChinaSOEBusinessModelData[index].ASUTotal = this.asuAndHYCOChinaSOEBusinessModelData[index].movingAvgInvestment;
          else if (this.asuAndHYCOChinaSOEBusinessModelData[index].primaryOfferingType == 'SMR')
            this.asuAndHYCOChinaSOEBusinessModelData[index].SMRTotal = this.asuAndHYCOChinaSOEBusinessModelData[index].movingAvgInvestment;
        }
      }, error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching China ASU and HYCO SOE BusinessModel data", error);
      }
    });
  }

  getChinaASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters) {
    this.isLoadPanelVisible = true;
    this.o2PortalAsuSmrReportService.getChinaASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters).subscribe({
      next: asuAndHYCOChinaSOGBusinessModelData => {
        this.asuAndHYCOChinaSOGBusinessModelData = asuAndHYCOChinaSOGBusinessModelData;
        for (let index = 0; index < this.asuAndHYCOChinaSOGBusinessModelData.length; ++index) {
          if (this.asuAndHYCOChinaSOGBusinessModelData[index].primaryOfferingType == 'ASU')
            this.asuAndHYCOChinaSOGBusinessModelData[index].ASUTotal = this.asuAndHYCOChinaSOGBusinessModelData[index].movingAvgInvestment;
          else if (this.asuAndHYCOChinaSOGBusinessModelData[index].primaryOfferingType == 'SMR')
            this.asuAndHYCOChinaSOGBusinessModelData[index].SMRTotal = this.asuAndHYCOChinaSOGBusinessModelData[index].movingAvgInvestment;
        }
        this.isLoadPanelVisible = false;
      }, error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching China ASU and HYCO SOG BusinessModel data", error);
      }
    });

  }

  getROWASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters) {
    this.isLoadPanelVisible = true;
    this.o2PortalAsuSmrReportService.getROWASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters).subscribe({
      next: asuAndHYCORowBusinessModelData => {
        this.asuAndHYCORowBusinessModelData = asuAndHYCORowBusinessModelData;
        for (let index = 0; index < this.asuAndHYCORowBusinessModelData.length; ++index) {
          if (this.asuAndHYCORowBusinessModelData[index].primaryOfferingType == 'ASU')
            this.asuAndHYCORowBusinessModelData[index].ASUTotal = this.asuAndHYCORowBusinessModelData[index].movingAvgInvestment;
          else if (this.asuAndHYCORowBusinessModelData[index].primaryOfferingType == 'SMR')
            this.asuAndHYCORowBusinessModelData[index].SMRTotal = this.asuAndHYCORowBusinessModelData[index].movingAvgInvestment;
        }
        this.isLoadPanelVisible = false;
      }, error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching ROW ASU and HYCO All BusinessModel data", error);
      }
    });
  }

  getROWASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters) {
    this.isLoadPanelVisible = true;
    this.o2PortalAsuSmrReportService.getROWASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters).subscribe({
      next: asuAndHYCORowSOEBusinessModelData => {
        this.asuAndHYCORowSOEBusinessModelData = asuAndHYCORowSOEBusinessModelData;
        for (let index = 0; index < this.asuAndHYCORowSOEBusinessModelData.length; ++index) {
          if (this.asuAndHYCORowSOEBusinessModelData[index].primaryOfferingType == 'ASU')
            this.asuAndHYCORowSOEBusinessModelData[index].ASUTotal = this.asuAndHYCORowSOEBusinessModelData[index].movingAvgInvestment;
          else if (this.asuAndHYCORowSOEBusinessModelData[index].primaryOfferingType == 'SMR')
            this.asuAndHYCORowSOEBusinessModelData[index].SMRTotal = this.asuAndHYCORowSOEBusinessModelData[index].movingAvgInvestment;
        }
        this.isLoadPanelVisible = false;
      }, error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching ROW ASU and HYCO SOE BusinessModel data", error);
      }
    });
  }

  getRowASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters) {
    this.isLoadPanelVisible = true;
    this.o2PortalAsuSmrReportService.getRowASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters).subscribe({
      next: asuAndHYCORowSOGBusinessModelData => {
        this.asuAndHYCORowSOGBusinessModelData = asuAndHYCORowSOGBusinessModelData;
        for (let index = 0; index < this.asuAndHYCORowSOGBusinessModelData.length; ++index) {
          if (this.asuAndHYCORowSOGBusinessModelData[index].primaryOfferingType == 'ASU')
            this.asuAndHYCORowSOGBusinessModelData[index].ASUTotal = this.asuAndHYCORowSOGBusinessModelData[index].movingAvgInvestment;
          else if (this.asuAndHYCORowSOGBusinessModelData[index].primaryOfferingType == 'SMR')
            this.asuAndHYCORowSOGBusinessModelData[index].SMRTotal = this.asuAndHYCORowSOGBusinessModelData[index].movingAvgInvestment;
        }
        this.showCharts = true;
        this.isLoadPanelVisible = false;
      }, error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching ROW ASU and HYCO SOG BusinessModel data", error);
      }
    });
  }

  getASUAndHYCOInvestmentReportData(asuAndHYCOInvestmentFilters) {
    if (asuAndHYCOInvestmentFilters) {
      this.getGlobalASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters);
      this.getGlobalASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters);
      this.getGlobalASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters);

      this.getChinaASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters);
      this.getChinaASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters);
      this.getChinaASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters);

      this.getROWASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters);
      this.getROWASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters);
      this.getRowASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters);
    }
  }

  convertElementToImage(elementId: string) {

    return html2canvas(document.getElementById(elementId), { useCORS: true, logging: true })
      .then((canvas: HTMLCanvasElement) => {
        return { elementId: elementId, dataURL: canvas.toDataURL("image/jpeg", 0.5) };
      });

  }

  async export() {
    this.isLoadPanelVisible = true;
    this.workbook = new Workbook();

    let worksheet = this.workbook.addWorksheet('Charts');

    // Export Maps as images.

    let images: Array<{ imageId: number, elementId: string }> = new Array();
    let promiseArray: Array<Promise<{ elementId: string, dataURL: string }>> = new Array();
    const promiseGlobalAllBusinessModelChart = this.convertElementToImage(this.globalAllBusinessModelChartId);
    const promiseGlobalSOEBusinessModelChart = this.convertElementToImage(this.globalSOEBusinessModelChartId);
    const promiseGlobalSOGBusinessModelChart = this.convertElementToImage(this.globalSOGBusinessModelChartId);

    const promiseChinaAllBusinessModelChart = this.convertElementToImage(this.chinaAllBusinessModelChartId);
    const promiseChinaSOEBusinessModelChart = this.convertElementToImage(this.chinaSOEBusinessModelChartID);
    const promiseChinaSOGBusinessModelChart = this.convertElementToImage(this.chinaSOGBusinessModelChartId);

    const promiseROWAllBusinessModelChart = this.convertElementToImage(this.rowAllBusinessModelChartId);
    const promiseROWSOEBusinessModelChart = this.convertElementToImage(this.rowSOEBusinessModelChartId);
    const promiseROWSOGBusinessModelChart = this.convertElementToImage(this.rowSOGBusinessModelChartId);

    promiseArray.push(promiseGlobalAllBusinessModelChart, promiseGlobalSOEBusinessModelChart, promiseGlobalSOGBusinessModelChart,
      promiseChinaAllBusinessModelChart, promiseChinaSOEBusinessModelChart, promiseChinaSOGBusinessModelChart,
      promiseROWAllBusinessModelChart, promiseROWSOEBusinessModelChart, promiseROWSOGBusinessModelChart);



    //Then we wait for all promises to resolve. The conversion to image takes some time.
    //Each promise resolves to an object of type {elementId: string, dataURL: string}        
    return Promise.all(promiseArray).then((values) => {

      let imageId = 0;

      //Here dataURL is the base64 format of the jpeg image. 
      //Adding image to workbook is a two step process. Fist step, add it to workbook and it gives back an imageId.          
      values.forEach(async obj => {
        imageId = await this.workbook.addImage({
          base64: obj.dataURL,
          extension: 'jpeg',
        });

        //Store all imageIds in an array, in next step these imageIds will be added to worksheet.
        images.push({ imageId: imageId, elementId: obj.elementId });
      });

    }).then(() => {
      let tlColMap = 0;
      let brColMap = 7;
      let tlCol: number, brCol: number;
      let tlRow: number, brRow: number;
      let header: number = 1;
      let chartSectionIndex = 0;

      for (let index = 0; index < 9;) {

        worksheet.mergeCells(`A${header}:N${header}`);
        worksheet.getCell(`A${header}`).value = {
          'richText': [
            {
              'font': {
                'size': 14, 'color': { 'argb': '1C3A70' },
                'name': 'Tahoma'
              }, 'text': this.chartSections[chartSectionIndex]
            },
          ]
        };

        chartSectionIndex = chartSectionIndex + 1;

        worksheet.getCell(`A${header}`).alignment = {
          vertical: 'middle',
          horizontal: 'center',
          wrapText: true
        };

        worksheet.getCell(`A${header}`).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'f2f2f2' },
        };

        header = header + 1;

        //First Chart
        tlCol = tlColMap;
        brCol = brColMap;
        tlRow = header + 1;
        brRow = header + 19
        //excelRow_Last = excelRow_Last + 20;
        //Add the image to the worksheet.
        worksheet.addImage(images[index].imageId, {
          tl: { col: tlCol, row: tlRow },
          br: { col: brCol, row: brRow }
        });

        // Second Chart
        index = index + 1;
        tlCol = 7;
        brCol = 14;
        tlRow = header + 1;
        brRow = header + 10;
        //excelRow_Last = excelRow_Last + 20;
        //Add the image to the worksheet.
        worksheet.addImage(images[index].imageId, {
          tl: { col: tlCol, row: tlRow },
          br: { col: brCol, row: brRow }
        });

        // Third Chart
        index = index + 1;
        tlCol = 7;
        brCol = 14;
        tlRow = header + 10;
        brRow = header + 19;
        //Add the image to the worksheet.
        worksheet.addImage(images[index].imageId, {
          tl: { col: tlCol, row: tlRow },
          br: { col: brCol, row: brRow }
        });

        header = header + 21;
        index = index + 1;

      }

    }).then(() => {
      let that = this;
      this.workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ASUHyCOAwardsCharts.xlsx');
          that.isLoadPanelVisible = false;
        });
    })
  }
}

